import LoginContainer from '@/views/login/login-container.vue'
import LoginView from '@/views/login/login-view.vue'
import LoginActivateView from '@/views/login/login-activate.view.vue'
import LoginActivateSuccessView from '@/views/login/login-activate-success.view.vue'
import AuthService from '@/services/auth.service'
export default [
  {
    path: '',
    component: LoginContainer,
    children: [
      {
        path: '/',
        name: 'login',
        component: LoginView,
        meta: {
          title: 'Bienvenido',
          access: ['*']
        },
        beforeEnter (to, from, next) {
          AuthService.isAuthenticated() ? next(AuthService.redirectURL) : next()
        }
      },
      {
        path: '/activate',
        name: 'login-activate',
        component: LoginActivateView,
        meta: {
          title: 'Activa tu cuenta',
          access: ['*']
        }
      },
      {
        path: '/activate-success',
        name: 'login-activate-success',
        component: LoginActivateSuccessView,
        meta: {
          title: 'Activa tu cuenta',
          access: ['*']
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/login/index.js